import { useState } from "react";
import DialogModal from "src/components/Dialog";
import Info from "src/components/Info";
import OverLappingClothes from "src/layouts/dashboard/Icons/AsoEbi";
import CreateGroup from "../modals/CreateGroup";
import styles from "./styles.module.scss";

function EmptyState() {
  const [open, setOpen] = useState(false);
  return (
    <div className={styles["EmptyState"]}>
      <Info>
        <p className={styles["EmptyState--title"]}>
          Aso-ebi allows you curate distinctive clothing group for your wedding
        </p>
      </Info>

      <div className={styles["EmptyState--main"]}>
        <div className="mb-[30px]">
          <OverLappingClothes />
        </div>
        <p>Sounds incredible, right? Let's create your first clothing group!</p>
        <DialogModal
          open={open}
          onOpenChange={setOpen}
          trigger={
            <div
              onClick={() => setOpen(true)}
              className={styles["EmptyState--main__trigger"]}
            >
              <span>Create</span>
            </div>
          }
        >
          <CreateGroup setOpen={setOpen} />
        </DialogModal>
      </div>
    </div>
  );
}

export default EmptyState;
